import React from 'react';
import { AlertCircle } from 'lucide-react';
import { coachQuestions, painCosts } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-sand-light" data-id="element-206" data-mp="2lmj1x3tsf9h9">
      <div className="max-w-4xl mx-auto" data-id="element-207" data-mp="26z7osxhyjhf1">
        <div className="text-center mb-12" data-id="element-208" data-mp="26y621vrkx6hh">
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-navy" data-id="element-209" data-mp="2bwzdzjr7wpfj">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-muted leading-relaxed bg-white p-6 md:p-10 rounded-2xl border border-line shadow-sm text-left space-y-5" data-id="element-210" data-mp="1xw6k918qpydh">
            <p className="text-ink font-medium" data-id="element-211" data-mp="1nztqy4h3xmj9">
              It’s the night before another mountain bike coaching session.
            </p>
            <p data-id="element-212" data-mp="1szg3ebp42yr0">You know MTB. You know how to coach. You know your riders.</p>
            <p data-id="element-213" data-mp="3idbi01gq11j1">But you’re still sitting there asking yourself:</p>
            <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 border-l-2 border-seafoam pl-5" data-id="element-214" data-mp="3nco1qdcapshe">
              {coachQuestions.map(q => <li key={q} className="text-navy italic" data-id="element-215" data-mp="1yzn5hoft1gi7">
                  {q}
                </li>)}
            </ul>
            <p data-id="element-216" data-mp="1u1bx7i55re23">
              And once they finally get it...{' '}
              <span className="text-navy italic font-semibold" data-id="element-217" data-mp="27rxfp5qp9lzg">What should I teach next?</span>
            </p>
            <p data-id="element-218" data-mp="23sopgauvc68n">
              <span className="text-forest font-semibold" data-id="element-219" data-mp="23s6r98onbhy3">
                Not because you don’t know what you’re doing.
              </span>{' '}
              Because knowing how to coach and having a complete professional coaching system
              already organized for you are two completely different things.
            </p>
            <p data-id="element-220" data-mp="1k3nykh4flmen">
              Without that structure, you keep rebuilding sessions from scratch. Searching for
              drills. Repeating exercises you already know. Improvising when something doesn’t
              work. And spending hours planning sessions that may only last 45 or 60 minutes.
            </p>
            <p data-id="element-221" data-mp="1t5oiwxoow7xb">
              The worst part? It isn’t only the time.{' '}
              <span className="text-ink font-semibold" data-id="element-222" data-mp="1y483ourjrdo3">
                It’s arriving to coach knowing you could have been more prepared.
              </span>
            </p>
          </div>
        </div>

        <h3 className="text-xl md:text-2xl font-bold text-navy mb-6 text-center" data-id="element-223" data-mp="274y122wghc3x">
          The Real Cost of Coaching Without a Complete System
        </h3>
        <ul className="overflow-hidden rounded-xl border border-line bg-white shadow-sm divide-y divide-line" data-id="element-224" data-mp="1ag8gu5xcw7es">
          {painCosts.map(cost => <li key={cost} className="px-5 py-4 flex items-start gap-3 text-ink text-base leading-relaxed" data-id="element-225" data-mp="1jfloct1x6lwv">
              <AlertCircle size={20} className="text-orange shrink-0 mt-0.5" aria-hidden="true" data-id="element-226" data-mp="1o6lkhw37szyb" />
              {cost}
            </li>)}
        </ul>

        <div className="text-center mt-12 pt-8 border-t border-line" data-id="element-227" data-mp="qolisdnxxa33">
          <p className="text-2xl md:text-3xl font-display font-extrabold text-forest" data-id="element-228" data-mp="vo6kgvuhvwji">
            Stop rebuilding your coaching system every week.
          </p>
          <p className="text-xl mt-4 text-muted" data-id="element-229" data-mp="j6ngou83919w">
            Your knowledge is already there. Your experience is already there.
          </p>
          <p className="text-xl mt-2 text-ink font-semibold" data-id="element-230" data-mp="e6hlx56iuynl">
            What you need is a system that helps you use both of them faster.
          </p>
        </div>
      </div>
    </section>;
}